import Api from '@/services/Api'

export default {
    getAllTercero(){
        return Api().get('tercero/getAll')
    },
    getTerceroById(id){
        return Api().get('tercero/terceroById/'+id)
    },
    createTercero(datos){
        return Api().post('tercero/create',datos)
    },
    updateTerceroById(datos){
        return Api().put('tercero/update',datos)
    },
    deleteTercero(id){
        return Api().delete('tercero/delete/'+id)
    }
}